import { Box, Dialog, Tab, Tabs } from "@mui/material";
import { IMeeting } from "../../../../types";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import ClientProvider from "../../../../modules/ClientProvider";
import { MeetingDetailsTab } from "./MeetingDetaillsTab";
import { MeetingSettingsTab } from "./MeetingSettingsTab";

interface MeetingModalProps {
    meetingUuid: string;
    reloadMeetings: () => Promise<void>;
    editMode: boolean;
    setEditMode: (mode: boolean) => void;
}

export const MeetingModal = ({
    meetingUuid,
    reloadMeetings,
    editMode,
    setEditMode
}: MeetingModalProps) => {

    const { getAccessTokenSilently } = useAuth0();
    const [meeting, setMeeting] = useState<IMeeting | null>(null);
    const [activeTab, setActiveTab] = useState<number>(0);

    const adminMeetingHttpClient = ClientProvider.provideAdminMeetingClient();

    const fetchMeeting = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data } = await adminMeetingHttpClient.getMeeting(accessToken, meetingUuid);
        if (data && data.meeting) {
            setMeeting(data.meeting);
        }
    }

    useEffect(() => {
        fetchMeeting();
    }, [meetingUuid]);

    const handleClose = () => {
        reloadMeetings();
        setEditMode(false);
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const handleSave = async () => {
        await fetchMeeting();
    }

    const handleCancel = () => {
        setEditMode(false);
    }

    if (!meeting) {
        return null;
    }

    return (
        <Dialog
            open={editMode}
            onClose={handleClose}
            fullWidth maxWidth="md"
        >
            <Box p={2} sx={{ width: '100%' }}>
                <div className="admin-modal-intro">
                    <h5>Meeting Details</h5>
                </div>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="Details" />
                    <Tab label="Settings" />
                </Tabs>
                {activeTab === 0 && (
                    <>
                        <MeetingDetailsTab meeting={meeting ?? null} onSaved={reloadMeetings} />
                    </>
                )}
                {activeTab === 1 && (
                    <MeetingSettingsTab meeting={meeting} onSave={handleSave} onCancel={handleCancel} />
                )}
            </Box>
        </Dialog>
    );
};